import {api} from "./api-config";
import {AxiosResponse} from "axios";

export const getAxios = (endpoint: string) => handle(
    api.get(endpoint)
)

export const deleteAxios = (endpoint: string, id: string) => handle(
    api.delete(`${endpoint}/${id}`)
)

export const postAxios = (endpoint: string, data: any) => handle(
    api.post(`${endpoint}`, data)
)

export const postFormAxios = (endpoint: string, data: any) => handle(
    api.post(`${endpoint}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
)

async function handle(axiosQuery: Promise<AxiosResponse>) {
    const response = await axiosQuery;
    return response.data;
}
